import React from 'react';

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  className?: string;
}

export function Textarea({ className = '', ...rest }: TextareaProps) {
  return <textarea className={'textarea ' + className} {...rest} />;
}

export default Textarea;
